module.exports = __webpack_public_path__ + "static/media/mawa3ed.c9f0467e.png";